import hoistNonReactStatic from 'hoist-non-react-statics'
import { useState } from 'react'
import { connect, useSelector, useDispatch } from 'react-redux'
import { Row, Col } from 'antd'

import Button from '~/core/Button'
import {
    ModalController,
    Modal,
    ModalHeader,
    ModalBody,
} from '~/components/Modal'
import { getModal, openModal, closeModal } from '~/redux-modules/modals'
import { signOutUser } from '~/redux-modules/identity'
import { LOGIN_PATH } from '~/redux-modules/preferences'

import styles from './styles.css'

export const NAME = 'MODAL_SESSION_TIMED_OUT'
const PLACEMENT = 'session-timeout-modal'

function ModalSessionTimedOut(props: { isOpen: boolean }) {
    const [isRefreshing, setRefreshing] = useState(false)
    const dispatch = useDispatch()

    const close = () => {
        setRefreshing(true)
        dispatch(signOutUser())
    }

    const { isOpen } = useSelector(state => {
        const modal = getModal(state, NAME)

        return {
            isOpen: modal.isOpen || props.isOpen,
        }
    })

    return (
        <ModalController isOpen={isOpen}>
            <Modal size="small" onBackgroundClick={close}>
                <ModalHeader onCloseClick={close}>Session timeout</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col className={styles.row} span={24}>
                            Your session has timed out.
                        </Col>
                        <Col className={styles.row} span={24}>
                            Please log in again to resume.
                        </Col>
                        <Col lg={24}>
                            <Button
                                type="primary"
                                block
                                loading={isRefreshing}
                                name="refresh-session"
                                placement={PLACEMENT}
                                onClick={close}
                            >
                                Log in
                            </Button>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </ModalController>
    )
}

ModalSessionTimedOut.open = () => {
    return window.location.pathname === LOGIN_PATH
        ? closeModal(NAME)
        : openModal(NAME)
}

const ConnectedComponent = connect()(ModalSessionTimedOut)

hoistNonReactStatic(ConnectedComponent, ModalSessionTimedOut)
export default ConnectedComponent
